import { createContext, useEffect, useReducer } from "react";
import axios from "../utils/axios";
import SmsProviderReducer from "../reducers/SmsProviderReducer";
import { isValidToken, setSession } from "../utils/jwt";
import { SmsProviderConstants } from "../constants/smsprovider.constants";
import { saveFile } from "../utils/common";
const initialState = {
  isLoading: true,
  smsProviders: [],
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  hasError: false,
  errorMessage: "",
  smsProviderSearchResults: [],
  smsProvider: {},
  isUpload: false,
  uploadError: false,
  uploadSuccess: false,
  isSubmitting: false,
  isLoadingDownload: false,
  smsProviderAutoSearchResults: {
    data: [],
    paging: {
      hasNextPage: false,
      hasPreviousPage: false,
      pageNumber: 0,
      pageSize: 0,
      totalNumberOfPages: 0,
      totalNumberOfRecords: 0,
    },
  },
  autoSearchLoading: false,
  isLoading: true,
  downloadFileType: "",
  isLoadingAutoSearch: true,
};
const initPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const SmsProviderContext = createContext({
  ...initialState,
  getAllSmsProvider: () => {},
  addSmsProvider: () => {},
  searchSmsProvider: () => {},
  autoSearchSmsProvider: () => {},
  getSmsProvider: () => {},
  updateSmsProvider: () => {},
  downloadFile: () => {},
  sampleFile: () => {},
  uploadFile: () => {},
});

function SmsProviderProvider({ children }) {
  const [state, dispatch] = useReducer(SmsProviderReducer, initialState);

  const getAllSmsProvider = async (payload) => {
    try {
      dispatch({
        type: SmsProviderConstants.FETCH_SMS_PROVIDER_REQUEST,
      });
      const response = await axios.post("/master/sms-provider/list", payload);
      dispatch({
        type: SmsProviderConstants.FETCH_SMS_PROVIDER_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: SmsProviderConstants.FETCH_SMS_PROVIDER_FAILURE,
      });
    }
  };
  const searchSmsProvider = async (payload) => {
    try {
      const response = await axios.post("/master/sms-provider/search", payload);
      dispatch({
        type: SmsProviderConstants.SMS_PROVIDER_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: SmsProviderConstants.SMS_PROVIDER_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: SmsProviderConstants.SMS_PROVIDER_SEARCH_FAILURE,
      });
    }
  };
  const autoSearchSmsProvider = async (payload) => {
    try {
      const response = await axios.post("/master/sms-provider/auto-search", payload);
      dispatch({
        type: SmsProviderConstants.SMS_PROVIDER_AUTO_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: SmsProviderConstants.SMS_PROVIDER_AUTO_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: SmsProviderConstants.SMS_PROVIDER_AUTO_SEARCH_FAILURE,
      });
    }
  };
  const addSmsProvider = async (payload) => {
    const response = await axios.post("/master/sms-provider/add", payload);
    dispatch({
      type: SmsProviderConstants.ADD_SMS_PROVIDER_REQUEST,
    });
    dispatch({
      type: SmsProviderConstants.ADD_SMS_PROVIDER_SUCCESS,
      payload: response.data,
    });
  };

  const getSmsProvider = async (id) => {
    const response = await axios.get("/master/sms-provider/" + id);
    dispatch({
      type: SmsProviderConstants.GET_SMS_PROVIDER_REQUEST,
    });
    dispatch({
      type: SmsProviderConstants.GET_SMS_PROVIDER_SUCCESS,
      payload: response.data,
    });
  };

  const updateSmsProvider = async (payload) => {
    const response = await axios.put(
      "/master/sms-provider/update/" + payload.smsProviderId,
      payload,
    );
    dispatch({
      type: SmsProviderConstants.UPDATE_SMS_PROVIDER_REQUEST,
    });
    dispatch({
      type: SmsProviderConstants.UPDATE_SMS_PROVIDER_SUCCESS,
      payload: response.data,
    });
  };

  const downloadFile = async (fileType, payload) => {
    dispatch({
      type: SmsProviderConstants.DOWNLOAD_SMS_PROVIDER_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post("/master/sms-provider/export/" + fileType, payload, {
      responseType: "blob",
    });
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "master/sms-provider." + fileType);
    dispatch({
      type: SmsProviderConstants.DOWNLOAD_SMS_PROVIDER_SUCCESS,
      payload: response.data,
    });
  };

  const sampleFile = async (fileType) => {
    const response = await axios.get("/master/sms-provider/sample/" + fileType, {
      responseType: "blob",
    });

    await saveFile(response.data, "sample_master/sms-provider." + fileType);
    dispatch({
      type: SmsProviderConstants.DOWNLOAD_SMS_PROVIDER_REQUEST,
    });
    dispatch({
      type: SmsProviderConstants.DOWNLOAD_SMS_PROVIDER_SUCCESS,
      payload: response.data,
    });
  };

  const uploadFile = async (payload) => {
    try {
      dispatch({
        type: SmsProviderConstants.UPLOAD_SMS_PROVIDER_REQUEST,
      });
      const response = await axios({
        url: "/master/sms-provider/upload",
        method: "POST",
        data: payload,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch({
        type: SmsProviderConstants.UPLOAD_SMS_PROVIDER_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.log("errr", error);
      dispatch({
        type: SmsProviderConstants.UPLOAD_SMS_PROVIDER_FAILURE,
      });
    }
  };

  return (
    <SmsProviderContext.Provider
      value={{
        ...state,
        getAllSmsProvider,
        addSmsProvider,
        searchSmsProvider,
        autoSearchSmsProvider,
        getSmsProvider,
        updateSmsProvider,
        downloadFile,
        sampleFile,
        uploadFile,
      }}
    >
      {children}
    </SmsProviderContext.Provider>
  );
}

export { SmsProviderContext, SmsProviderProvider };
